import { SheetFillStyle } from './AbstractSheetFilledShape';
import {
  AbstractSheetShape,
  SheetShapeStyleType,
} from 'src/components/viewers/SheetsViewerV2/shapes/abstract/AbstractSheetShape';
import {
  DefaultLineStyle,
  HoveredLineStyle,
  SelectedLineStyle,
} from 'src/components/viewers/SheetsViewerV2/SheetsViewerV2.config';
import { boostColorBrightness } from 'src/utils/color-util';

export enum LineStyle {
  Solid = 0,
  DashedSmall = 1,
  DashedMedium = 2,
  DashedLarge = 3,
  DottedSmall = 4,
  DottedMedium = 5,
  DottedLarge = 6,
  DottedXLarge = 7,
  DashedXLarge = 8,
  DashedXXLarge = 9,
  DashedXXXLarge = 10,
}

export type SheetLineStyle = {
  lineWidth: number;
  lineColor: string;
  lineStyle: number;
};
export type SheetLineStyleSet = {
  [key in SheetShapeStyleType]: SheetLineStyle;
};
export type SheetFillStyleSet = {
  [key in SheetShapeStyleType]: SheetFillStyle;
};

export abstract class AbstractSheetLineShape extends AbstractSheetShape {
  protected styleSet: SheetLineStyleSet | null = null;

  protected setStyle(type: SheetShapeStyleType) {
    // eslint-disable-next-line complexity
    this.shapes.forEach((shape) => {
      switch (type) {
        case SheetShapeStyleType.default:
          shape.style.lineWidth =
            this.styleSet?.[SheetShapeStyleType.default]?.lineWidth ??
            DefaultLineStyle.lineWidth;
          shape.style.lineColor =
            this.styleSet?.[SheetShapeStyleType.default]?.lineColor ??
            DefaultLineStyle.lineColor;
          break;
        case SheetShapeStyleType.hovered: {
          const defaultLineColor =
            this.styleSet?.[SheetShapeStyleType.default]?.lineColor ??
            DefaultLineStyle.lineColor;

          shape.style.lineWidth =
            this.styleSet?.[SheetShapeStyleType.hovered]?.lineWidth ??
            HoveredLineStyle.lineWidth;
          shape.style.lineColor = boostColorBrightness(defaultLineColor);
          break;
        }
        case SheetShapeStyleType.selected:
          shape.style.lineWidth =
            this.styleSet?.[SheetShapeStyleType.selected]?.lineWidth ??
            SelectedLineStyle.lineWidth;
          shape.style.lineColor =
            this.styleSet?.[SheetShapeStyleType.selected]?.lineColor ??
            SelectedLineStyle.lineColor;
          break;
      }
    });
  }
}
